// BlogStats.js
import React, { useState, useEffect } from "react";
import axios from "axios";
import { useAuth } from "../../AuthContext";
import "./BlogStats.css";

const BlogStats = () => {
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const { token } = useAuth();

  useEffect(() => {
    const fetchStats = async () => {
      try {
        setLoading(true);
        const response = await axios.get(
          `${process.env.REACT_APP_API_BASE_URL}/blog/stats`,
          { headers: { Authorization: `Bearer ${token}` } }
        );
        setStats(response.data);
        setError(null);
      } catch (err) {
        setError("Failed to fetch blog statistics");
        console.error(err);
      } finally {
        setLoading(false);
      }
    };

    fetchStats();
  }, [token]);

  if (loading) return <div className="loading">Loading statistics...</div>;
  if (error) return <div className="error">{error}</div>;
  if (!stats) return <div className="error">No statistics available</div>;

  return (
    <div className="blog-stats">
      <h2>Blog Statistics</h2>

      <div className="stats-grid">
        <div className="stat-card">
          <div className="stat-value">{stats.totalPosts}</div>
          <div className="stat-label">Total Posts</div>
        </div>

        <div className="stat-card">
          <div className="stat-value">{stats.publishedPosts}</div>
          <div className="stat-label">Published</div>
        </div>

        <div className="stat-card">
          <div className="stat-value">{stats.draftPosts}</div>
          <div className="stat-label">Drafts</div>
        </div>

        <div className="stat-card">
          <div className="stat-value">{stats.pendingApprovalPosts}</div>
          <div className="stat-label">Pending Approval</div>
        </div>
      </div>

      <div className="most-viewed-posts">
        <h3>Most Viewed Posts</h3>

        {stats.mostViewedPosts.length === 0 ? (
          <p>No view data available yet</p>
        ) : (
          <table>
            <thead>
              <tr>
                <th>Title</th>
                <th>Views</th>
              </tr>
            </thead>
            <tbody>
              {stats.mostViewedPosts.map((post) => (
                <tr key={post._id}>
                  <td>{post.title}</td>
                  <td>{post.viewCount}</td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
};

export default BlogStats;
